

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"24"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('path', {"fill":"#FFF","d":"m14.284 17.778-5.657-5.657a1 1 0 1 1 1.414-1.414l3.957 3.957L14 1a1 1 0 0 1 2 0v13.65l3.944-3.943a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414l-5.657 5.657a.996.996 0 0 1-.648.291h-.121a.996.996 0 0 1-.648-.29Z"}, []), h('path', {"stroke":"#FFF","stroke-linecap":"round","stroke-width":"2","d":"M20.114 5h4.261c2.353 0 4.261 2.015 4.261 4.5v9c0 2.485-1.908 4.5-4.261 4.5H5.625c-2.354 0-4.261-2.015-4.261-4.5v-9C1.364 7.015 3.27 5 5.625 5h4.261"}, [])])]);
};

        